import { AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";
import { BpsAdminDashboardData } from "../model/bps-admin/bps-admin-dashboard-data";
import moment from "moment";
import { LoanSummaryResponse } from "../pages/admin/loan-summary/LoanSummaryPage";
import { FileObject } from "../model/common/file-object";
import { BpsAdminDashboardChartDataList } from "../model/bps-admin/bps-admin-dashboard-chart-data-list";

class BpsAdminService {
    private instance: HttpService;
    private controllerName: string = 'bps-admin'; 

    constructor() {
        this.instance = new HttpService(this.controllerName);
    }

    public async getDashboardData(): Promise<AxiosResponse<BpsAdminDashboardData>> {
        return this.instance.get('dashboard');
    }

    public async getDashboardChartData(startDate: Date, endDate: Date): Promise<AxiosResponse<BpsAdminDashboardChartDataList>> {
        const start = moment(startDate).format();
        const end = moment(endDate).format();
        return this.instance.get('dashboard/chart', { params: { startDate: start, endDate: end } });
    }

    public async postDownloadChartData(obj: BpsAdminDashboardChartDataList): Promise<AxiosResponse<any>> {
        return this.instance.post('dashboard/chart/download', obj, { responseType: 'blob'});
    }

    public async getLoanSummaryData() : Promise<AxiosResponse<LoanSummaryResponse>> {
        return this.instance.get('loan-summary');
    }
}

const bpsAdminService = new BpsAdminService();

export default bpsAdminService;
